export default function (props: any) {
    return (
        <svg width="80" height="80" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <path d="M55.183 43.492 32.493 59.56a2 2 0 0 1-3.156-1.633V22.53a2 2 0 0 1 3.156-1.633l22.69 16.066a4 4 0 0 1 0 6.53z" fill="#FFF" />
                <circle stroke="#FFF" strokeWidth="2" opacity=".304" cx="40" cy="40" r="39" />
            </g>
        </svg>
    );
}
